import {useContext, useMemo} from 'react';
import {getScheduleHours, getTimeInCityWithUTCOffset, getWeekDayNameFromDate, isUserInTime} from 'core/helpers/dates';
import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';
import {IExpressOrder} from 'plugins/modules/filter/types';

export const useWineshopWarningText = (wineShop?: IExpressOrder) => {
    const {cityData} = useContext(FilterPickupTodayButtonContext);

    return useMemo(() => {
        if (!cityData || !wineShop || !wineShop?.typedSchedule?.length) {
            return '';
        }

        const date = getTimeInCityWithUTCOffset(cityData.utcOffset);
        const currentWeekDayName = getWeekDayNameFromDate(date);

        const currentSchedule = wineShop.typedSchedule.find(({day}) => {
            return day.toLowerCase() === currentWeekDayName.toLowerCase();
        });

        if (!currentSchedule || !currentSchedule.from || !currentSchedule.to) {
            return '';
        }

        const cityHours = date.getHours();
        const {from, to} = currentSchedule;

        const fromHours = getScheduleHours(from);
        const toHours = getScheduleHours(to);
        const isInTime = isUserInTime(cityHours, fromHours, toHours);

        if (!isInTime) {
            return 'Винотека уже закрыта. Вы можете оформить заказ и получить его после открытия винотеки.';
        }

        if (20 <= cityHours && 22 > cityHours) {
            return 'Успейте сделать заказ до закрытия ближайшей винотеки.';
        }

        return '';
    }, [cityData, wineShop]);
};
